import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import { FullscreenTakeover } from "@jsq/ds/core";
import { globalEnv } from "~/global-env";
import CreateCaseForm from "../CreateCaseForm";
import { CaseCreationPreview } from "../documents/CaseCreationPreview";
import { CaseFormProvider } from "./CaseFormContext";
import { InvestorProfileCreationModal } from "./InvestorProfileCreationModal";
import { formBody } from "./styles_vanilla.css";

export const CreateCaseNavigation = () => {
  const history = useHistory();
  const match = useRouteMatch();

  const onCancelExit = () => {
    history.push(`${globalEnv.complianceRoute}`);
  };

  return (
    <CaseFormProvider>
      <FullscreenTakeover>
        <FullscreenTakeover.Header onExit={onCancelExit} title={"Create new case"} />
        <Switch>
          <Route path={`${match.path}/extraction/preview`} exact>
            <CaseCreationPreview />
          </Route>
          <Route path={`${match.path}`}>
            <FullscreenTakeover.Body className={formBody}>
              <CreateCaseForm inAiExtractionMode />
              <Route path={`${match.path}/extraction`} exact>
                <InvestorProfileCreationModal />
              </Route>
            </FullscreenTakeover.Body>
          </Route>
        </Switch>
      </FullscreenTakeover>
    </CaseFormProvider>
  );
};
